import { Fragment, createElementBlock, createTextVNode, defineComponent, nextTick, normalizeStyle, onBeforeUnmount, onMounted, openBlock, ref, renderList, renderSlot, toDisplayString, toRefs, unref, watch } from "vue";
import { useMasonryWall } from "@yeger/vue-masonry-wall-core";

//#region src/masonry-wall.vue?vue&type=script&setup=true&lang.ts
const _hoisted_1 = ["data-index"];
var masonry_wall_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "masonry-wall",
	props: {
		columnWidth: { default: 400 },
		items: {},
		gap: { default: 0 },
		rtl: {
			type: Boolean,
			default: false
		},
		ssrColumns: { default: 0 },
		scrollContainer: { default: null },
		minColumns: { default: 1 },
		maxColumns: {},
		keyMapper: {}
	},
	emits: ["redraw", "redrawSkip"],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const columns = ref([]);
		const wall = ref();
		const { getColumnWidthTarget } = useMasonryWall({
			columns,
			emit,
			nextTick,
			onBeforeUnmount,
			onMounted,
			vue: 3,
			wall,
			watch,
			...toRefs(props)
		});
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "wall",
				ref: wall,
				class: "masonry-wall",
				style: normalizeStyle({
					display: "flex",
					gap: `${__props.gap}px`
				})
			}, [(openBlock(true), createElementBlock(Fragment, null, renderList(columns.value, (column, columnIndex) => {
				return openBlock(), createElementBlock("div", {
					key: columnIndex,
					class: "masonry-column",
					"data-index": columnIndex,
					style: normalizeStyle({
						"display": "flex",
						"flex-basis": `${unref(getColumnWidthTarget)(columnIndex)}px`,
						"flex-direction": "column",
						"flex-grow": 1,
						"gap": `${__props.gap}px`,
						"height": [
							"-webkit-max-content",
							"-moz-max-content",
							"max-content"
						],
						"min-width": 0
					})
				}, [(openBlock(true), createElementBlock(Fragment, null, renderList(column, (itemIndex, row) => {
					return openBlock(), createElementBlock("div", {
						key: __props.keyMapper?.(__props.items[itemIndex], columnIndex, row, itemIndex) ?? itemIndex,
						class: "masonry-item"
					}, [renderSlot(_ctx.$slots, "default", {
						item: __props.items[itemIndex],
						column: columnIndex,
						columnCount: columns.value.length,
						row,
						index: itemIndex
					}, () => [createTextVNode(toDisplayString(__props.items[itemIndex]), 1)])]);
				}), 128))], 12, _hoisted_1);
			}), 128))], 4);
		};
	}
});

//#endregion
//#region src/masonry-wall.vue
var masonry_wall_default = masonry_wall_vue_vue_type_script_setup_true_lang_default;

//#endregion
//#region src/index.ts
const MasonryWall = /* @__PURE__ */ (() => {
	const installable = masonry_wall_default;
	installable.install = (app) => {
		app.component("MasonryWall", installable);
	};
	return installable;
})();
var src_default = MasonryWall;

//#endregion
export { src_default as default };
//# sourceMappingURL=index.js.map